module.exports = __webpack_public_path__ + "static/media/charging-station.14081be6.svg";